import { render, staticRenderFns } from "./ComposedTab.vue?vue&type=template&id=2ee2b146&scoped=true"
import script from "./ComposedTab.vue?vue&type=script&lang=js"
export * from "./ComposedTab.vue?vue&type=script&lang=js"
import style0 from "./ComposedTab.vue?vue&type=style&index=0&id=2ee2b146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee2b146",
  null
  
)

export default component.exports